import ReduxTypes from "../consts/ReduxTypes";
import { store } from "../store";
import { showSnackbar } from "../components/SharedComponents/Notifier";

export const sessionExpired = () => {
  store.dispatch({ type: ReduxTypes.LOGOUT_USER });
  showSnackbar("Session has been expired.");
};
